import { useEffect } from 'react';

/** Sets document.title as "<title> – Recipes Manager" while the component is mounted. */
export function useDocumentTitle(title: string | undefined) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `${title} – Recipes Manager`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
